import { render } from "./PhotoSelectorFromFileTab.vue?vue&type=template&id=43b20d1a"
import script from "./PhotoSelectorFromFileTab.vue?vue&type=script&lang=js"
export * from "./PhotoSelectorFromFileTab.vue?vue&type=script&lang=js"

import "./PhotoSelectorFromFileTab.vue?vue&type=style&index=0&id=43b20d1a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__